import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    bannerAdminList: [],
    initateLoading: false,
    arrangeOrder: 'asc',
    arrangeKey: 'id',
    error: null,
    closeReleaseBannerAdminForm: false,
};

const ReleaseBannerAdminReducerSlice = createSlice({
    name: 'releaseBannerAdminReducer',
    initialState,
    reducers: {
        initReleaseBannerAdminLoading: (state) => {
            state.initateLoading = true;
            state.error = null;
        },
        setReleaseBannerAdminList: (state, action) => {
            state.bannerAdminList = action.payload || [];
            state.initateLoading = false;
        },
        setReleaseBannerAdminError: (state, action) => {
            state.error = action.payload;
            state.initateLoading = false;
        },
        updateReleaseBannerAdminArrangeOrder: (state, action) => {
            state.arrangeOrder = action.payload;
        },
        updateReleaseBannerAdminArrangeKey: (state, action) => {
            state.arrangeKey = action.payload;
        },
        setCloseReleaseBannerAdminForm: (state, action) => {
            state.closeReleaseBannerAdminForm = action.payload;
        },
    },
});

export const {
    initReleaseBannerAdminLoading,
    setReleaseBannerAdminList,
    setReleaseBannerAdminError,
    updateReleaseBannerAdminArrangeOrder,
    updateReleaseBannerAdminArrangeKey,
    setCloseReleaseBannerAdminForm,
} = ReleaseBannerAdminReducerSlice.actions;

export const getReleaseBannerAdminSelector = (state) => state.releaseBannerAdminReducer;

export default ReleaseBannerAdminReducerSlice.reducer;